import React from "react";
import PostForm from "../components/post/PostForm";

const PostCreate = () => {
  return (
    <>
      <PostForm />
    </>
  );
};

export default PostCreate;
